import { debounce } from "./functions";

// ALWAYS STORE DATE IN YYYY-MM-DD

const dateFieldNameRegex = /^(.*)_(d|m|y)$/;

let dateInputHandler = (event) => {
    let target = $(event.target);
    let value = target.val();
    let id = target[0].id;
    let nameMatches = dateFieldNameRegex.exec(id);
    let part = nameMatches[2];
    let inputName = nameMatches[1];
    if (event.type === 'keyup') {
        if (['d', 'm'].includes(part) && /^\d{2}$/.test(value)) {
            if (part == 'd') {
                $('#' + inputName + '_m').focus();
            }
            if (part == 'm') {
                $('#' + inputName + '_y').focus();
            }
        }
    }

    if (event.type === 'change') {
        // Deal with the day and month trailing 0
        if (['d', 'm'].includes(part) && /^\d{1}$/.test(value) && value >= 1 && value < 10) {
            value = '0' + value;
            target.val(value);
        }
        // Deal with the year autofilling
        if (part === 'y' && /^\d{2}$/.test(value)) {
            if (value < 19) {
                value = '20' + value;
                target.val(value);
            } else {
                value = '19' + value;
                target.val(value);
            }
        }
        // Stick them together and put them in the hidden field
        let dateInput = $('[name=' + inputName + ']');
        let oldValue = dateInput.val();
        let day = $('#' + inputName + '_d').val();
        let month = $('#' + inputName + '_m').val();
        let year = $('#' + inputName + '_y').val();
        if (/^\d{2}$/.test(day) 
            && /^\d{2}$/.test(month)
            && /^\d{4}$/.test(year) && year > 0) {
                let newValue = year + '-' + month + '-' + day;
                if (oldValue != newValue) {
                    dateInput.val(newValue).change();
                }
        } else {
            if (oldValue != '') {
                dateInput.val('').change();
            }
        }
    }
};

$(document).on('keyup', '[id$=_d], [id$=_m], [id$=_y]', debounce(dateInputHandler, 150, false));
$(document).on('change', '[id$=_d], [id$=_m], [id$=_y]', dateInputHandler);